var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("breadcrumbs", {
        attrs: { two: { path: "/tuning", name: this.page_title } },
      }),
      _c("div", { staticClass: "main" }, [
        _c("h3", [_vm._v(_vm._s(_vm.page_title))]),
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _vm.loading ? _c("loading") : _vm._e(),
            !_vm.loading
              ? _c(
                  "div",
                  [
                    _c(
                      "el-row",
                      [
                        _c("el-col", { attrs: { span: 24 } }, [
                          _c(
                            "div",
                            {
                              staticClass: "el-card box-card is-always-shadow",
                            },
                            [
                              _c("div", { staticClass: "el-card__header" }, [
                                _c("div", { staticClass: "clearfix" }, [
                                  _c("span", [_vm._v("Фильтры")]),
                                ]),
                              ]),
                              _c(
                                "div",
                                { staticClass: "el-card__body" },
                                [
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticClass: "mb-2",
                                          attrs: {
                                            span: 6,
                                            xs: 24,
                                            sm: 12,
                                            md: 12,
                                            lg: 6,
                                            xl: 6,
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "demo-input-label" },
                                            [_vm._v("Бренд: ")]
                                          ),
                                          _c("br"),
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                filterable: "",
                                                placeholder:
                                                  "Начните вводить/выберите",
                                              },
                                              model: {
                                                value: _vm.filterBrandID,
                                                callback: function ($$v) {
                                                  _vm.filterBrandID = $$v
                                                },
                                                expression: "filterBrandID",
                                              },
                                            },
                                            _vm._l(
                                              _vm.brands_list,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.id,
                                                  attrs: {
                                                    label: item.name,
                                                    value: item.id,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    { attrs: { gutter: 24 } },
                                    [
                                      _c(
                                        "el-col",
                                        [
                                          _c("el-button", {
                                            attrs: {
                                              type: "success",
                                              round: "",
                                              icon: "el-icon-check",
                                              title: "Фильтр",
                                            },
                                            on: { click: _vm.getData },
                                          }),
                                          _c("el-button", {
                                            attrs: {
                                              type: "danger",
                                              round: "",
                                              icon: "el-icon-close",
                                              title: "Очистить",
                                            },
                                            on: { click: _vm.resetFilters },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-table",
                      {
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.items, border: "", stripe: "" },
                        on: { "sort-change": _vm.filterChange },
                      },
                      [
                        [
                          _c("el-table-column", {
                            attrs: { label: "Бренд", prop: "brand_name" },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Название", prop: "name" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "a",
                                        {
                                          attrs: {
                                            href:
                                              "/tuning/item/" +
                                              scope.row.tuning_id,
                                          },
                                        },
                                        [_vm._v(_vm._s(scope.row.name))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1492007482
                            ),
                          }),
                        ],
                      ],
                      2
                    ),
                    !_vm.loading
                      ? _c("el-pagination", {
                          staticClass: "pagination",
                          attrs: {
                            background: "",
                            layout: "pager",
                            total: _vm.totalElements,
                            "page-size": _vm.numberOfElements,
                            "current-page": _vm.page,
                          },
                          on: {
                            "update:currentPage": function ($event) {
                              _vm.page = $event
                            },
                            "update:current-page": function ($event) {
                              _vm.page = $event
                            },
                            "current-change": _vm.setCurrentPage,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }